
import ModalBox from '@/commons/components/modal-box/ModalBox.vue'
import { Component, Prop, Vue } from 'vue-property-decorator'
import { ApplicationDocument } from '@/commons/types'
import i18n from '@/commons/translations/i18n'
import ModalBoxIsLostStolenDestroyedContent
    from '@/commons/components/modal-box/ModalBoxIsLostStolenDestroyedContent.vue'

@Component({
    components: {
        ModalBox
    }
})
export default class ModalBoxIsLostStolenDestroyed extends Vue {
    @Prop() applicationDocument!: ApplicationDocument

    modalBoxBodyInstance (): Vue {
        return new ModalBoxIsLostStolenDestroyedContent(
            {
                name: 'isLostStolenDestroyedModal',
                i18n: i18n,
                propsData: {
                    closeCallback: this.closeModal,
                    applicationDocument: this.applicationDocument
                }
            })
    }

    closeModal (): void {
        this.applicationDocument.reason = null
        this.applicationDocument.reasonExplanation = null
    }
}
